document.addEventListener('DOMContentLoaded', function() {
  let relatedCollectionsSwiper;

  // Check if related collections grid exists
  const relatedCollectionsGrid = document.querySelector('.related-collections-grid');
  
  if (relatedCollectionsGrid) {
    // Initialize swiper for related collections
    relatedCollectionsSwiper = new Swiper('.related-collections-grid', {
      spaceBetween: 80,
      freeMode: true,
      slidesPerView: 'auto'
    });
  }

  
});